




















































































































































































































































import { Component, Vue, Mixins } from "vue-property-decorator";
import {
  selectAllLabel,
  selectDiscountById,
  updateDiscountById,
  deleteDiscountTag,
  createDiscountTag,
  updateEnterAudit,
  getEnterAudit,
} from "@/api/discount";
import { allParentList} from "@/api/system";
import { Res } from "@/types/common/index";
import { CreateDiscountTag, Discount, DiscountCom } from "@/types/api/discount";
// 混入
import Loading from "@/mixins/loading";
import TablePagination from "@/mixins/tablePagination";
// 工具
import inputPrice from "@/utils/inputPrice";
import copy from "@/utils/deepCopy";

// 初始化表单
const initForm: DiscountCom = {
  id: 0,
  preStoreCost: 0,
  discountValue: 0,
  discountLabel: "",
  giveAmount:0,
  experiencePoint:0
};

@Component
export default class settledPlatform extends Mixins(Loading, TablePagination) {
  discount: Array<Discount> = [
    {
      name: "企业/门店",
      data: [],
    },
    {
      name: "个人/学员",
      data: [],
    },
  ];
  dialogVisible: boolean = false;
  placeholder: string = "";
  type: string = "预存费用";
  tags: Array<CreateDiscountTag> = []; // 标签列表
  dialogVisibleAdd: boolean = false; // 添加标签对话框
  // 标签表单
  form: DiscountCom = initForm;
  // 费用
  feeForm: { value: number | string } = {
    value: 0,
  };
  //入驻模块审核0表示不自动审核，1表示自动审核
  enterAudit = false;
  giveAmountDisabled = false;

  /**
   * 生命周期
   */
  mounted() {
    this.getData();
  }

  /**
   * methods
   */
  // 获取数据
  async getData() {
    this.showLoading();

    //是否开启自动审核功能
    await getEnterAudit().then((res: any) => {
      const enterAuditDict = res.data.dictValue;
      this.enterAudit = (enterAuditDict > 0);
    });

    // 企业
    let p1 = await selectDiscountById({ id: 2 }).then((res: any) => {
      this.discount[0].data = [];
      this.discount[0].data.push(res.data);
    });
    // 个人、学员
    let p2 = await selectDiscountById({ id: 1 }).then((res: any) => {
      this.discount[1].data = [];
      this.discount[1].data.push(res.data);
    });
    this.getAllTags();
    this.hideLoading();
  }
  // 获取所有标签
  getAllTags(): void {
    selectAllLabel().then((res: any) => {
      res.data.forEach((e: any) => {
        e.discountValue = e.discountValue * 100;
      });
      this.tags = res.data;
    });
  }
  // 编辑
  edit(row: any, type: string) {
    this.form = copy(row);
    this.type = "edit";
    this.dialogVisibleAdd = true;
  }
  // 确认修改
  confirm(formName: string): void {
    let refs: any = this.$refs[formName];
    const preStoreCost = this.form.preStoreCost;
    if(preStoreCost == 0){
      this.form.giveAmount = 0;
      this.form.experiencePoint = 0;
    }
    refs.validate((valid: boolean) => {
      if (valid) {
        let prom = null;
        let dis: any = copy(this.form);
        dis.discountValue = (dis.discountValue / 100).toFixed(2);
        if (this.type == "add") {
          delete dis.id;
          prom = createDiscountTag(dis);
        } else {
          prom = updateDiscountById(dis);
        }
        prom.then((res: any) => {
          this.dialogVisibleAdd = false;
          this.form = copy(initForm);
          this.getAllTags();
          this.$message.success(res.message);
        });
      } else {
        return false;
      }
    });
  }
  // 删除标签
  handleDeleteTag(row: any) {
    this.$confirm(`是否要删除${row.discountLabel} ?`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      deleteDiscountTag({ id: row.id }).then((res: any) => {
        this.getAllTags();
        this.$message({
          type: "success",
          message: "删除成功!",
        });
      });
    });
  }
  // 显示创建标签对话框
  createTag(): void {
    this.type = "add";
    this.dialogVisibleAdd = true;
  }
  // 创建标签
  confirmAdd(formName: string): void {
    let refs: any = this.$refs[formName];
    refs.validate((valid: boolean) => {
      if (valid) {
        delete this.form.id;
        createDiscountTag(this.form).then((rs: any) => {
          this.form = copy(initForm);
          this.dialogVisibleAdd = false;
          this.getAllTags();
        });
      } else {
        return false;
      }
    });
  }
  // 取消表单
  cancelDialog() {
    this.dialogVisibleAdd = false;
    this.form = copy(initForm);
  }
  // 限制只能输入数字，而且只能保留两位小数
  limitInput(val: any, key: string) {
    this.$set(this.form, key, inputPrice(val));
    this.changeGiveAmount();
  }
  changeGiveAmount(){
    const preStoreCost = this.form.preStoreCost;
    if(preStoreCost == 0){
      this.giveAmountDisabled = true
    }else{
       this.giveAmountDisabled = false
    }
  }

  //是否开启自动审核功能
  changeEnterAudit(enterAudit:boolean){
    let status = enterAudit ? 1 : 0;
    this.showLoading();
    updateEnterAudit({status:status}).then((res: any) => {
        this.hideLoading();
        this.$message({
          type: enterAudit ? 'success' : 'warning',
          message: enterAudit ? '开启自动审核功能' : '关闭自动审核功能',
        });
    }).catch((err)=>{
      this.hideLoading();
    });
  }
}
